import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { SEL } from "@/components/employes/shared";

const CONTRATS = ["CDI", "CDD", "CTA", "DAIP / ANEM", "Stage", "Saisonnier"];

export const EmployeDialog = ({ employe, onClose, onSaved }) => {
  const { societes, societeId } = useApp();
  const [v, setV] = useState({
    societe_id: employe?.societe_id || (societeId !== "all" ? societeId : ""), nom: "", prenom: "", poste: "", date_embauche: "",
    date_fin: "", type_contrat: "CDI", conges_annuels: 30, telephone: "", observations: "", ...employe,
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });

  const save = async () => {
    if (!v.societe_id || !v.nom || !v.date_embauche) return toast.error("Société, nom et date d'embauche obligatoires");
    setSaving(true);
    const body = { ...v, date_fin: v.date_fin || null, conges_annuels: Number(v.conges_annuels) || 0 };
    try {
      await (employe ? api.put(`/employes/${employe.id}`, body) : api.post("/employes", body));
      toast.success(employe ? "Employé modifié" : "Employé ajouté");
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur d'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  const field = (k, l, type = "text") => (
    <label className="text-xs text-muted-foreground space-y-1">{l}
      <Input type={type} value={v[k] ?? ""} onChange={set(k)} data-testid={`employe-input-${k}`} />
    </label>
  );

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-card max-w-xl" data-testid="employe-dialog">
        <DialogHeader><DialogTitle>{employe ? "Modifier l'employé" : "Nouvel employé"}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs text-muted-foreground space-y-1 col-span-2">Société
            <select className={SEL} value={v.societe_id} onChange={set("societe_id")} data-testid="employe-input-societe">
              <option value="">— Choisir —</option>
              {societes.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </label>
          {field("nom", "Nom")}
          {field("prenom", "Prénom")}
          {field("poste", "Poste")}
          <label className="text-xs text-muted-foreground space-y-1">Type de contrat
            <select className={SEL} value={v.type_contrat} onChange={set("type_contrat")} data-testid="employe-input-type_contrat">
              {CONTRATS.map((c) => <option key={c}>{c}</option>)}
            </select>
          </label>
          {field("date_embauche", "Date d'embauche", "date")}
          {field("date_fin", "Fin d'embauche / fin de contrat", "date")}
          {field("conges_annuels", "Droits à congé annuels (jours)", "number")}
          {field("telephone", "Téléphone")}
          <div className="col-span-2">{field("observations", "Observations")}</div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="employe-cancel">Annuler</Button>
          <Button onClick={save} disabled={saving} data-testid="employe-save">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
